import Box from "../components/Box/Box";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUnregisterFlow } from "../hooks/useUnregisterFlow";

export default function UnregisterTravelSuccess() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const { unregisterData } = useUnregisterFlow();
    const navigate = useNavigate();

    useEffect(() => {
        if (!unregisterData) {
            navigate("/avboka-resa");
            return;
        }

        const { EditId, ReferenceId, email } = unregisterData;

        if (!EditId || !ReferenceId) {
            navigate("/avboka-resa-fel");
            return;
        }
    }, [unregisterData, navigate]);

    return (
        <div>
            <Box>
                <h2 ref={h2Ref}>Er gruppresa är avanmäld!</h2>
                <p>
                    Gruppresa med referensnummer{" "}
                    {unregisterData?.ReferenceId} är avanmäld och borttagen.
                </p>
                <h2 ref={h2Ref}>Behöver ni anmäla en ny gruppresa?</h2>
                <p>
                    Ibland blir det inte som man tänkt sig. Vi hjälper er att anmäla en ny gruppresa.
                </p>
                <button
                    type="button"
                    onClick={() => navigate("/")}
                    className="stripped md:hover:underline md:hover:decoration-1 focus-visible:underline focus-visible:decoration-1 md:active:underline md:active:decoration-2  focus-visible:outline focus-visible:outline-2 focus-visible:outline-focus focus-visible:outline-offset-4 text-red-darker text-lg inline-flex items-center md:hover:underline"
                >
                    Anmäl gruppresa
                    <FontAwesomeIcon className="ml-2" icon={solid("chevron-right")} />
                </button>
            </Box>
        </div>
    );
}
